export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4793.faf8683d.jpg";